/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export const ALLOWED_PRINCIPAL_TYPES = ['settlement_agent', 'insurance_qc_agent', 'ops_desk_agent', 'title_agent', 'notary', 'attorney', 'loan_processor', 'multi_tenant_tpr'];

// These permission Ids are copied from the identity-sdk because the
// identity-sdk is not compatible with the client.
export const BridgePermissions = {
  BridgeCredentials: 'a35b1001-19bd-4430-80ee-bb6217828e44',
  BridgePipeline: '7f08e336-2864-476e-922a-8c67a1b27c2d',
  BridgeProfile: 'f9632c86-ee48-4a9f-80e5-4ccd98e11d56',
  BSRAdmin: '15e0186f-07fe-4608-b38f-b99a9995fb7d',
  BSRAppointments: '88f3f1a4-625d-49b0-94ea-b0d4373d616f',
  BSRJournal: 'dc2656d2-4b2c-4d02-a6f8-c53f1ce8c582',
  BSRRooms: '7a488d70-9995-4233-8210-4b63bf7a8014'
};
export const PERMISSION_NAMES = Object.keys(BridgePermissions).reduce((memo, permissionName) => {
  memo[permissionName] = permissionName;
  return memo;
}, {});
export let BlendBridge;
(function (_BlendBridge) {
  let TaskTypes = /*#__PURE__*/function (TaskTypes) {
    TaskTypes["FORM"] = "FORM";
    TaskTypes["REDIRECT"] = "REDIRECT";
    TaskTypes["SCHEDULE_CLOSING_APPOINTMENT"] = "SCHEDULE_CLOSING_APPOINTMENT";
    TaskTypes["SCHEDULE_CLOSING_APPOINTMENT_HYBRID_TRADITIONAL"] = "SCHEDULE_CLOSING_APPOINTMENT_HYBRID_TRADITIONAL";
    TaskTypes["SCHEDULE_CLOSING_APPOINTMENT_RON"] = "SCHEDULE_CLOSING_APPOINTMENT_RON";
    TaskTypes["SELECT_RON_PROVIDER"] = "SELECT_RON_PROVIDER";
    TaskTypes["SHARE"] = "SHARE";
    TaskTypes["TAGGING"] = "TAGGING";
    TaskTypes["RELEASE_CLOSING_DOCUMENTS"] = "RELEASE_CLOSING_DOCUMENTS";
    TaskTypes["UPLOAD_DOCUMENT"] = "UPLOAD_DOCUMENT";
    TaskTypes["UPLOAD_FILE"] = "UPLOAD_FILE";
    TaskTypes["CANCEL_CLOSING_DOCUMENTS"] = "CANCEL_CLOSING_DOCUMENTS";
    return TaskTypes;
  }({});
  _BlendBridge.TaskTypes = TaskTypes;
  let ServiceTypes = /*#__PURE__*/function (ServiceTypes) {
    ServiceTypes["ECLOSE"] = "ECLOSE";
    ServiceTypes["FAST_TRACK"] = "FAST_TRACK";
    ServiceTypes["RON"] = "RON";
    ServiceTypes["TITLE"] = "TITLE";
    return ServiceTypes;
  }({});
  _BlendBridge.ServiceTypes = ServiceTypes;
  let ExternalServiceTypes = /*#__PURE__*/function (ExternalServiceTypes) {
    ExternalServiceTypes["AGENCIES"] = "AGENCIES";
    ExternalServiceTypes["EMAIL_COORDINATOR"] = "EMAIL_COORDINATOR";
    ExternalServiceTypes["MESSENGER"] = "MESSENGER";
    ExternalServiceTypes["PRICING"] = "PRICING";
    ExternalServiceTypes["CONFIGURABLE_PRODUCTS"] = "CONFIGURABLE_PRODUCTS";
    return ExternalServiceTypes;
  }({});
  _BlendBridge.ExternalServiceTypes = ExternalServiceTypes;
  let UserPreferenceServiceTypes = /*#__PURE__*/function (UserPreferenceServiceTypes) {
    UserPreferenceServiceTypes["ECLOSE"] = "ECLOSE";
    return UserPreferenceServiceTypes;
  }({});
  _BlendBridge.UserPreferenceServiceTypes = UserPreferenceServiceTypes;
  let TaskStatuses = /*#__PURE__*/function (TaskStatuses) {
    TaskStatuses["CANCELLED"] = "CANCELLED";
    TaskStatuses["COMPLETE"] = "COMPLETE";
    TaskStatuses["LOCKED"] = "LOCKED";
    TaskStatuses["OPEN"] = "OPEN";
    return TaskStatuses;
  }({});
  _BlendBridge.TaskStatuses = TaskStatuses;
  let DocumentActions = /*#__PURE__*/function (DocumentActions) {
    DocumentActions["DELETE"] = "DELETE";
    DocumentActions["DOWNLOAD"] = "DOWNLOAD";
    DocumentActions["VIEW"] = "VIEW";
    return DocumentActions;
  }({});
  _BlendBridge.DocumentActions = DocumentActions;
  let AddressTypes = /*#__PURE__*/function (AddressTypes) {
    AddressTypes["HOME"] = "HOME";
    AddressTypes["OTHER"] = "OTHER";
    AddressTypes["WORK"] = "WORK";
    return AddressTypes;
  }({});
  _BlendBridge.AddressTypes = AddressTypes;
  let PipelineGroupSettings = /*#__PURE__*/function (PipelineGroupSettings) {
    PipelineGroupSettings["SHOW_ALL"] = "SHOW_ALL";
    PipelineGroupSettings["SHOW_ASSIGNED_TO_GROUP_AND_SELF"] = "SHOW_ASSIGNED_TO_GROUP_AND_SELF";
    PipelineGroupSettings["SHOW_ASSIGNED_TO_SELF_ONLY"] = "SHOW_ASSIGNED_TO_SELF_ONLY";
    return PipelineGroupSettings;
  }({});
  _BlendBridge.PipelineGroupSettings = PipelineGroupSettings;
  let FileTypes = /*#__PURE__*/function (FileTypes) {
    FileTypes["CLOSING_PACKAGE"] = "CLOSING_PACKAGE";
    FileTypes["NOTARY_COMMISSION"] = "NOTARY_COMMISSION";
    FileTypes["NOTARY_DIGITAL_CERTIFICATE"] = "NOTARY_DIGITAL_CERTIFICATE";
    FileTypes["TITLE_DOCUMENT"] = "TITLE_DOCUMENT";
    return FileTypes;
  }({});
  _BlendBridge.FileTypes = FileTypes;
  let AllowedFileExtensions = /*#__PURE__*/function (AllowedFileExtensions) {
    AllowedFileExtensions["DOC"] = ".doc";
    AllowedFileExtensions["DOCX"] = ".docx";
    AllowedFileExtensions["JPEG"] = ".jpeg";
    AllowedFileExtensions["JPG"] = ".jpg";
    AllowedFileExtensions["P12"] = ".p12";
    AllowedFileExtensions["PDF"] = ".pdf";
    AllowedFileExtensions["PNG"] = ".png";
    AllowedFileExtensions["RTF"] = ".rtf";
    AllowedFileExtensions["TXT"] = ".txt";
    return AllowedFileExtensions;
  }({});
  _BlendBridge.AllowedFileExtensions = AllowedFileExtensions;
  let GroupRoles = /*#__PURE__*/function (GroupRoles) {
    GroupRoles["ADMIN"] = "ADMIN";
    GroupRoles["AUDITOR"] = "AUDITOR";
    GroupRoles["MEMBER"] = "MEMBER";
    GroupRoles["OWNER"] = "OWNER";
    return GroupRoles;
  }({});
  _BlendBridge.GroupRoles = GroupRoles;
  let TaskViewTypes = /*#__PURE__*/function (TaskViewTypes) {
    TaskViewTypes["DASHBOARD_HEADER"] = "DASHBOARD_HEADER";
    TaskViewTypes["DASHBOARD_OVERVIEW"] = "DASHBOARD_OVERVIEW";
    TaskViewTypes["PROFILE_CREDENTIALS"] = "PROFILE_CREDENTIALS";
    return TaskViewTypes;
  }({});
  _BlendBridge.TaskViewTypes = TaskViewTypes;
  let AuditEventTypes = /*#__PURE__*/function (AuditEventTypes) {
    AuditEventTypes["LOAN_EVENT"] = "LOAN_EVENT";
    AuditEventTypes["TASK_EVENT"] = "TASK_EVENT";
    AuditEventTypes["USER_EVENT"] = "USER_EVENT";
    return AuditEventTypes;
  }({});
  _BlendBridge.AuditEventTypes = AuditEventTypes;
  let Tasks;
  (function (_Tasks) {
    let NotaryCredentialUploadTasksUUID = /*#__PURE__*/function (NotaryCredentialUploadTasksUUID) {
      NotaryCredentialUploadTasksUUID["DIGITAL_CERTIFICATE"] = "fdaceeec-9111-472d-a81b-b9b00323150f";
      NotaryCredentialUploadTasksUUID["GENERAL_COMMISSION"] = "9c3656c4-45f7-4b68-b62e-f6e4b2c57fc6";
      NotaryCredentialUploadTasksUUID["RON_COMMISSION"] = "22450f6c-895c-46e9-9301-b8cca20e0250";
      return NotaryCredentialUploadTasksUUID;
    }({}); // SEAL = 'caad30b5-7f01-4fac-972d-92cf01d1c7bf',
    // SIGNATURE = '6e21f889-eb15-4dd7-b5c8-1affcebe3c15',
    _Tasks.NotaryCredentialUploadTasksUUID = NotaryCredentialUploadTasksUUID;
  })(Tasks || (Tasks = _BlendBridge.Tasks || (_BlendBridge.Tasks = {})));
  let API;
  (function (_API) {
    let TaskDescriptionTypes = /*#__PURE__*/function (TaskDescriptionTypes) {
      TaskDescriptionTypes["CHECKBOX"] = "CHECKBOX";
      TaskDescriptionTypes["FILE_INPUT"] = "FILE_INPUT";
      TaskDescriptionTypes["HIDDEN_INPUT"] = "HIDDEN_INPUT";
      TaskDescriptionTypes["INPUT"] = "INPUT";
      TaskDescriptionTypes["LABEL"] = "LABEL";
      TaskDescriptionTypes["TEXT"] = "TEXT";
      TaskDescriptionTypes["TEXT_INPUT"] = "TEXT_INPUT";
      TaskDescriptionTypes["TYPEAHEAD"] = "TYPEAHEAD";
      return TaskDescriptionTypes;
    }({});
    _API.TaskDescriptionTypes = TaskDescriptionTypes;
    let InputCategories = /*#__PURE__*/function (InputCategories) {
      InputCategories["DATE_PICKER"] = "DATE_PICKER";
      InputCategories["US_STATES_DROP_DOWN"] = "US_STATES_DROP_DOWN";
      return InputCategories;
    }({});
    _API.InputCategories = InputCategories;
    let ScheduleClosingAppointmentTaskClosingTypes = /*#__PURE__*/function (ScheduleClosingAppointmentTaskClosingTypes) {
      ScheduleClosingAppointmentTaskClosingTypes["BLEND_SIGNING_ROOM"] = "BLEND_SIGNING_ROOM";
      ScheduleClosingAppointmentTaskClosingTypes["HYBRID"] = "HYBRID";
      ScheduleClosingAppointmentTaskClosingTypes["NOTARYCAM"] = "NOTARYCAM";
      ScheduleClosingAppointmentTaskClosingTypes["RON"] = "RON";
      ScheduleClosingAppointmentTaskClosingTypes["TRADITIONAL"] = "TRADITIONAL";
      ScheduleClosingAppointmentTaskClosingTypes["UNDETERMINED"] = "UNDETERMINED";
      return ScheduleClosingAppointmentTaskClosingTypes;
    }({});
    _API.ScheduleClosingAppointmentTaskClosingTypes = ScheduleClosingAppointmentTaskClosingTypes;
    let DirectUrlOpenMethod = /*#__PURE__*/function (DirectUrlOpenMethod) {
      DirectUrlOpenMethod["IFRAME_MODAL"] = "iframeModal";
      DirectUrlOpenMethod["NEW_TAB"] = "newTab";
      DirectUrlOpenMethod["REDIRECT"] = "redirect";
      return DirectUrlOpenMethod;
    }({});
    _API.DirectUrlOpenMethod = DirectUrlOpenMethod;
    let FetchUrlOpenMethod = /*#__PURE__*/function (FetchUrlOpenMethod) {
      FetchUrlOpenMethod["FETCH_AND_DECIDE"] = "fetchAndDecide";
      return FetchUrlOpenMethod;
    }({});
    _API.FetchUrlOpenMethod = FetchUrlOpenMethod;
    let LockType = /*#__PURE__*/function (LockType) {
      LockType["FEE"] = "FEE";
      return LockType;
    }({});
    _API.LockType = LockType;
    let EntityType = /*#__PURE__*/function (EntityType) {
      EntityType["BLEND_TITLE_AGENCY"] = "BLEND_TITLE_AGENCY";
      EntityType["LOAN_OFFICER"] = "LOAN_OFFICER";
      return EntityType;
    }({});
    _API.EntityType = EntityType;
    let Topic = /*#__PURE__*/function (Topic) {
      Topic["FEE_COLLABORATION"] = "FEE_COLLABORATION";
      Topic["FUNDING"] = "FUNDING";
      Topic["OTHER"] = "OTHER";
      Topic["POST_CLOSING"] = "POST_CLOSING";
      Topic["PROCESSING"] = "PROCESSING";
      Topic["SCHEDULING_CLOSING"] = "SCHEDULING_CLOSING";
      Topic["TITLE"] = "TITLE";
      return Topic;
    }({});
    _API.Topic = Topic;
    let TaskResponseAllowedHttpStatusCode = /*#__PURE__*/function (TaskResponseAllowedHttpStatusCode) {
      TaskResponseAllowedHttpStatusCode[TaskResponseAllowedHttpStatusCode["OK"] = 200] = "OK";
      TaskResponseAllowedHttpStatusCode[TaskResponseAllowedHttpStatusCode["INVALID_REQUEST"] = 400] = "INVALID_REQUEST";
      TaskResponseAllowedHttpStatusCode[TaskResponseAllowedHttpStatusCode["NOT_FOUND"] = 404] = "NOT_FOUND";
      TaskResponseAllowedHttpStatusCode[TaskResponseAllowedHttpStatusCode["CONFLICT"] = 409] = "CONFLICT";
      TaskResponseAllowedHttpStatusCode[TaskResponseAllowedHttpStatusCode["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
      return TaskResponseAllowedHttpStatusCode;
    }({});
    _API.TaskResponseAllowedHttpStatusCode = TaskResponseAllowedHttpStatusCode;
    let GroupRoles = /*#__PURE__*/function (GroupRoles) {
      GroupRoles["ADMIN"] = "ADMIN";
      GroupRoles["AUDITOR"] = "AUDITOR";
      GroupRoles["MEMBER"] = "MEMBER";
      GroupRoles["OWNER"] = "OWNER";
      return GroupRoles;
    }({});
    _API.GroupRoles = GroupRoles;
    let GroupInvitationStatuses = /*#__PURE__*/function (GroupInvitationStatuses) {
      GroupInvitationStatuses["ACCEPTED"] = "ACCEPTED";
      GroupInvitationStatuses["DECLINED"] = "DECLINED";
      GroupInvitationStatuses["SENT"] = "SENT";
      return GroupInvitationStatuses;
    }({});
    _API.GroupInvitationStatuses = GroupInvitationStatuses;
    let GroupInvitationTypes = /*#__PURE__*/function (GroupInvitationTypes) {
      GroupInvitationTypes["JOIN"] = "JOIN";
      GroupInvitationTypes["SHARE"] = "SHARE";
      return GroupInvitationTypes;
    }({});
    _API.GroupInvitationTypes = GroupInvitationTypes;
  })(API || (API = _BlendBridge.API || (_BlendBridge.API = {})));
  let LDS;
  (function (_LDS) {
    let PipelineFieldNames = /*#__PURE__*/function (PipelineFieldNames) {
      PipelineFieldNames["OPS_DESK_AGENT_EMAIL"] = "opsDeskAgentEmail";
      PipelineFieldNames["OPS_DESK_AGENT_FIRST_NAME"] = "opsDeskAgentFirstName";
      PipelineFieldNames["OPS_DESK_AGENT_LAST_NAME"] = "opsDeskAgentLastName";
      PipelineFieldNames["OPS_DESK_AGENT_MIDDLE_NAME"] = "opsDeskAgentMiddleName";
      PipelineFieldNames["OPS_DESK_AGENT_NOTES"] = "opsDeskAgentNotes";
      return PipelineFieldNames;
    }({});
    _LDS.PipelineFieldNames = PipelineFieldNames;
    let PublicFieldNames = /*#__PURE__*/function (PublicFieldNames) {
      PublicFieldNames["PIPELINE_DATA"] = "Bridge.pipelineData";
      return PublicFieldNames;
    }({});
    _LDS.PublicFieldNames = PublicFieldNames;
  })(LDS || (LDS = _BlendBridge.LDS || (_BlendBridge.LDS = {})));
})(BlendBridge || (BlendBridge = {}));